import { ACCESS_MODES } from "../utils/apiTarget";

// Two links, same app: the read-only one talks to the public API, the read-write one talks
// to the VPN-only internal API (see API_BASE_URLS in utils/apiTarget.js).
export const DB_INTERFACE_ROUTES = {
  [ACCESS_MODES.readOnly]: { production: "/dbInterface", development: "/dbInterfaceTest" },
  [ACCESS_MODES.readWrite]: { production: "/dbInterfaceWrite", development: "/dbInterfaceTestWrite" },
};

export function getDbInterfaceRoutePath(accessMode, isDev) {
  return DB_INTERFACE_ROUTES[accessMode][isDev ? "development" : "production"];
}

// Phase 3 (TOTP step-up). Flip once the /dbInterface/mfa/* endpoints are live.
export const DB_INTERFACE_STEP_UP_ENABLED = false;
